import { format } from 'date-fns';

export const formatTimeRange = (startTime: string, endTime: string) => {
  return `${format(new Date(startTime), 'HH:mm')} - ${format(
    new Date(endTime),
    'HH:mm',
  )}`;
};
